import { TFunction } from 'i18next';


const EnumMapping: Record<string, string> = {
    ASSET_INSTALL: 'Install Asset',
    ASSET_REMOVE: 'Remove Asset',
    ASSET_DELETE: 'Delete Asset',
    ASSET_MAINTENANCE: 'Maintenance',
    ASSET_REPAIR: 'Repair',
    ASSET_ONSITE_INTERVENTION: 'On-site Intervention',
    ASSET_VACUUM_CHECK: 'Vacuum Check',
    ASSET_IOT_COMMISSIONING: 'IoT Commissioning',
    ASSET_LOCATION_CREATE: 'Create Asset Location',
    ASSET_LOCATION_REMOVE: 'Remove Asset Location',
};

export const formatEventEnum = (value: string | undefined | null, t: TFunction): string => {
    if (!value) return '';

    if (EnumMapping[value]) {
        return t(EnumMapping[value]);
    }

    // Fallback to a generic formatting if the value is not in the mapping
    const formattedString = value.replace(/_/g, ' ').toLowerCase();
    return formattedString.charAt(0).toUpperCase() + formattedString.slice(1);
};

export default formatEventEnum;